var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageIcon = function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.667 14.278H3.333A2.446 2.446 0 0 1 .89 11.834V5.167a2.446 2.446 0 0 1 2.444-2.444h9.334a2.446 2.446 0 0 1 2.444 2.444v6.667a2.446 2.446 0 0 1-2.444 2.444M3.333 4.056c-.612 0-1.11.499-1.11 1.111v6.667c0 .595.47 1.082 1.058 1.11l4.99-4.991a2.447 2.447 0 0 1 3.457 0l2.05 2.049V5.167c0-.612-.499-1.111-1.111-1.111zm2.89 2.889a1.111 1.111 0 1 1-2.223 0 1.111 1.111 0 0 1 2.222 0",
    clipRule: "evenodd"
  })));
};
export default SvgImageIcon;